export const GET_BUILDING_AGE_CATEGORIES_DATA_REQUEST = "GET_BUILDING_AGE_CATEGORIES_DATA_REQUEST";
export const GET_BUILDING_AGE_CATEGORIES_DATA_SUCCESS = "GET_BUILDING_AGE_CATEGORIES_DATA_SUCCESS";
export const GET_BUILDING_AGE_CATEGORIES_DATA_FAILURE = "GET_BUILDING_AGE_CATEGORIES_DATA_FAILURE";

export const UPDATE_BUILDING_AGE_CATEGORIES_REQUEST = "UPDATE_BUILDING_AGE_CATEGORIES_REQUEST";
export const UPDATE_BUILDING_AGE_CATEGORIES_SUCCESS = "UPDATE_BUILDING_AGE_CATEGORIES_SUCCESS";
export const UPDATE_BUILDING_AGE_CATEGORIES_FAILURE = "UPDATE_BUILDING_AGE_CATEGORIES_FAILURE";

export const BuilidngAgeColorTable = {
    keys: ["name", "color_code"],
    config: {
        name: {
            label: "Name",
            class: ""
        },
        color_code: {
            label: "Color",
            class: "clr-cen"
        }
    },
    data: []
};
